import { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface RankedRow {
  key: string | number;
  label: ReactNode;
  value: number;
}

interface TarefaRankedListProps {
  rows: RankedRow[];
  emptyText: string;
}

// Top 3 ganham cor de "pódio"; do 4º em diante é neutro.
const RANK_BADGE = [
  "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  "bg-slate-400/15 text-slate-600 dark:text-slate-300",
  "bg-orange-500/15 text-orange-600 dark:text-orange-400",
];
const RANK_BAR = ["bg-amber-500", "bg-slate-400", "bg-orange-500"];

export function TarefaRankedList({ rows, emptyText }: Readonly<TarefaRankedListProps>) {
  if (rows.length === 0) {
    return <p className="py-8 text-center text-sm italic text-muted-foreground">{emptyText}</p>;
  }

  const max = Math.max(...rows.map((r) => r.value), 1);

  return (
    <div className="space-y-0.5">
      {rows.map((r, i) => (
        <div
          key={r.key}
          className="group flex items-center gap-3 rounded-lg px-2 py-2 transition-colors hover:bg-muted/50"
        >
          <span
            className={cn(
              "flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-bold tabular-nums",
              RANK_BADGE[i] ?? "bg-muted text-muted-foreground",
            )}
          >
            {i + 1}
          </span>

          <div className="min-w-0 flex-1 space-y-1.5">
            <div className="flex items-center justify-between gap-2">
              <span className="flex min-w-0 items-center gap-2 truncate text-sm font-medium text-foreground">
                {r.label}
              </span>
              <span className="shrink-0 font-mono text-sm font-bold tabular-nums text-foreground">
                {r.value}
              </span>
            </div>
            <div className="h-1.5 overflow-hidden rounded-full bg-muted">
              <div
                className={cn("h-full rounded-full transition-all", RANK_BAR[i] ?? "bg-primary")}
                style={{ width: `${Math.max((r.value / max) * 100, 6)}%` }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
